import { makeAutoObservable, toJS } from 'mobx'

import { CalendarPrice } from 'shared/api/tours/calendar'

class CalendarTourStore {
  prices: CalendarPrice | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setPrice(data: CalendarPrice) {
    this.prices = data
  }

  getPrice() {
    return toJS(this.prices)
  }

  clearPrice() {
    this.prices = null
  }
}

export default new CalendarTourStore()
